import React from "react";
import "./stylesheet/cinemaHallButtonsStyle.css";
import useCinemaHallButtons from "./hooks/useCinemaHallButtons";

interface IProps {
  activeStep: number;
  setActiveStep: (value: number) => void;
  totalBasket: number;
  validateBasket: Function;
  onClearBasket: Function;
}

const CinemaHallButtons: React.FC<IProps> = ({
  activeStep,
  setActiveStep,
  totalBasket,
  validateBasket,
  onClearBasket,
}: IProps) => {
  const { isVisible, title, handleGoBack, handleGoNext, buttonDisabled } = useCinemaHallButtons(
    activeStep,
    setActiveStep,
    totalBasket,
    validateBasket,
    onClearBasket
  );
  return (
    <div className={`checkout-buttons-wrapper ${!isVisible && "unvisible"}`}>
      <h1>{title}</h1>
      <div className="cinema-hall-button-group">
        {activeStep !== 0 && (
          <button className="ticket-summary-button clear" onClick={handleGoBack}>
            Cofnij
          </button>
        )}
        <button className={`ticket-summary-button ${buttonDisabled && "disabled"}`} onClick={handleGoNext}>
          Przejdź dalej
        </button>
      </div>
    </div>
  );
};

export default CinemaHallButtons;
